import { render, staticRenderFns } from "./PrepAssignmentCopy2.vue?vue&type=template&id=0a870d94&"
import script from "./PrepAssignmentCopy2.vue?vue&type=script&lang=js&"
export * from "./PrepAssignmentCopy2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports